import { QChange } from "./QChange";

export class QTableChange extends QChange {
  constructor() {
    super();
  }

  ApplyTheChange() {}

  /**
   * Produces a QTableChange from append-table save data.
   *
   * If the override already has an active change, the incoming delta is merged into it.
   * If not, a fresh QTableChange is created with the full delta.
   */
  static FromAppendTableData(override, changes) {
    const changeType = override.SmartGetFieldValue("Type");
    const existing = override.lastActiveChange();

    const newChange = existing ? existing : new QTableChange();

    if (!existing) {
      newChange.fDelta = changes;
      newChange.fChangeType = changeType;
    } else {
      const delta = newChange.fDelta ?? {};
      for (const key in changes) {
        delta[key] = changes[key];
      }
      newChange.fDelta = delta;
    }

    return newChange;
  }
}
